
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import ticketItem from './ticketItem.vue'
import rejectDialog from './components/rejectDialog.vue'
import finishedDialog from './components/finishedDialog.vue'
import forwardDialog from './components/forwardDialog.vue'
import detailDialog from './components/detailDialog.vue'
import editDialog from './components/editDialog.vue'
import rateDialog from '@/views/rate/rateDialog.vue'
import editDialogLive from './components/editDialogLive.vue'
import editDialogAdministration from '@/views/Ticket/components/editDialogFwbz.vue'
import { ORDERAPI } from '@/api/orders'
import { TicketsModule } from '@/store/modules/tickets'
import { AppModule, DeviceType } from '@/store/modules/app'
import { getuserCurrentApp } from '@/utils/cookies'
import { downloadLink } from '@/utils/commonFunc'
import { CONFIGAPI } from '@/api/config'
import UnpendingDialog from '@/views/Ticket/components/unpendingDialog.vue'
import PendingDialog from '@/views/Ticket/components/pendingDialog.vue'
import { FWBZISORDERAPI } from '@/api/fwbz.ts'

@Component({
  name: 'TicketFwbz',
  components: {
    PendingDialog,
    UnpendingDialog,
    ticketItem,
    rejectDialog,
    finishedDialog,
    forwardDialog,
    detailDialog,
    editDialog,
    rateDialog,
    editDialogLive,
    editDialogAdministration
  }
})
export default class extends Vue {
  @Prop({ default: 'getAllOrderLists' }) private methodName!: string;
  @Prop({ default: false }) private showStatusTab!: boolean;
  @Prop({ default: true }) private showHeaderType!: boolean;
  @Prop({ default: false }) private showHeaderUser!: boolean;
  private isNotManagerMethod = ['getAllMyCreatedOrderLists']; // 发起人权限的方法名
  private total = 0;
  private currentPage = 0;
  private pageSize = 10;
  private listData: Array<any> = [];
  private moreLoading = false; // 加载更多
  private pageLoading: any = null; // 页面加载中, 相当于蒙层功能，限制用户多次点击无效
  private headerStatus = (this.$route.query.status || '').toString() || '0'; // 工单状态tab
  private headerType = 0; // 工单类型
  private headerIsMine = 1; // 只看我的
  private datetimeSelect = []; // 当前所选时间
  private allBuilding = []; // 所有的基地（关联基地需要）
  private areaOption = 'place_0'; // 地区，默认全部
  private issueType1Option = '0';
  private issueType2Option = '0';
  private issueType1Options = []; // 问题类型options-父类
  private issueType2Options = []; // 问题类型options-子类

  private expireTimeOption: object = {
    disabledDate(time: any) {
      return time.getTime() > Date.now()
    }
  };

  get userCurrentApp() {
    return getuserCurrentApp()
  }

  get isShowHighLevelSearch() {
    return this.$route.name !== 'myCreateedOrders'
  }

  get device() {
    return AppModule.device
  }

  get isMobile() {
    return this.device === DeviceType.Mobile
  }

  // 正在操作的工单项
  get currentTicket() {
    return TicketsModule.currentTicket
  }

  // 正在操作的工单index
  get currentTicketIndex() {
    return TicketsModule.currentTicketIndex || 0
  }

  get noMore() {
    return this.pageSize * this.currentPage >= this.total
  }

  get disabled() {
    return this.moreLoading || this.noMore
  }

  get getShowHeaderUser() {
    return this.showHeaderUser && [2, 3, 4].includes(Number(this.headerStatus))
  }

  get containerHeight() {
    const statusTabH = this.showStatusTab ? 40 : 0
    const typeH = this.showHeaderType ? 35 : 0
    const userH = this.getShowHeaderUser ? 35 : 0
    return `calc(100vh - ${statusTabH + typeH + userH + 50}px)`
  }

  // navbar搜索值
  get navbarSearch() {
    return AppModule.navbarSearch
  }

  // navbar搜索框改变时，刷新
  @Watch('navbarSearch')
  private onNavbarSearchChange(value: string) {
    this.refreshFirstPage()
  }

  mounted() {
    this.getTutorIssueType().then((_) => {
      this.queryUrlParams()
      this.load()
    })
    // 展示navbar搜索框；
    AppModule.SetShowNavbarSearch(true)
    if (
      [
        'allOrders',
        'ordersCenter',
        'myCreateedOrders',
        'myManagedOrders'
      ].indexOf(this.$route.name as string) !== -1
    ) {
      this.getAllBuilding()
    }
  }

  beforeDestroy() {
    // 隐藏navbar搜索框；
    AppModule.SetShowNavbarSearch(false)
    // 关闭弹框，否则再次进入时依旧为打开状态
    TicketsModule.CloseAllDialog()
  }

  private queryUrlParams() {
    const parentId = this.$route.query.parentId
    const issueName = this.$route.query.issueName

    if (!parentId && issueName) {
      const parentData: any = this.issueType1Options.filter(
        (item: any) => item.label === issueName
      )
      if (parentData.length > 0) {
        this.issueType1Option = parentData[0].id
        this.issueType2Options = parentData[0].children
      }
    } else if (issueName) {
      for (let i = 0; i < this.issueType1Options.length; i++) {
        for (const item of (this.issueType1Options[i] as any).children) {
          if (item.label === issueName && item.parent_id === parentId) {
            this.issueType1Option = item.parent_id
            this.issueType2Option = item.id
            this.issueType2Options = (
              this.issueType1Options[i] as any
            ).children
            break
          }
        }
      }
    }
  }

  // 获取问题类型
  private async getTutorIssueType() {
    const { data } = await CONFIGAPI.getIssuesType({
      app_id: this.userCurrentApp
    })
    const newData: any = []
    // 删掉掉没有基地的地区
    data.map((item: any) => {
      if (item.children && item.children.length !== 0) {
        newData.push(item)
      }
    })
    this.issueType1Options = newData
  }

  // 获取全部基地树状结构
  getAllBuilding() {
    CONFIGAPI.getBuildingTree({
      app_id: this.userCurrentApp
    })
      .then((res) => {
        if (res.stat === 1) {
          const buildingList: any = []
          // 禁用掉没有基地的地区, 移除转接基地
          res.data.map((item: any) => {
            if (!item.children || item.children.length === 0) {
              item.disabled = true
            }
            if (item.label.indexOf('转接') === -1) {
              buildingList.push(item)
            }
          })
          this.allBuilding = buildingList
        }
      })
      .catch((error) => {
        console.log('发生错误！', error)
      })
  }

  private load() {
    // 滑到底部时进行加载
    this.moreLoading = true
    this.currentPage += 1
    this.getLists(this.getHeaderParams())
  }

  // 获取列表数据
  private getLists(params?: any) {
    this.moreLoading = true
    this.pageLoading = this.$loading({
      lock: true,
      spinner: 'le',
      background: 'rgba(255, 255, 255, 0.2)'
    });
    (this as any)[this.methodName](params)
  }

  // 兼容大屏幕, 大屏幕高度不够时继续加载；
  private loadHugeScreen() {
    Vue.nextTick(() => {
      if (!this.noMore) {
        const parentH =
          document.getElementsByClassName('ticket-wrapper')[0].clientHeight
        const childH =
          document.getElementsByClassName('ticket-row')[0].clientHeight
        if (childH < parentH) {
          this.load()
        }
      }
    })
  }

  private handleTabClick() {
    this.refreshFirstPage()
  }

  private handleTypeChange(e: any = null, issueType: any = null) {
    if (issueType) {
      const data: any = this.issueType1Options.filter(
        (item: any) => item.id === e
      )
      this.issueType2Options = data.length ? data[0].children : []
      this.issueType2Option = '0'
    }
    this.refreshFirstPage()
  }

  private handleTypeSubChange() {
    this.refreshFirstPage()
  }

  private handleMineChange() {
    this.refreshFirstPage()
  }

  private handleDatetimeChange() {
    // when clearable is null
    if (this.datetimeSelect === null) {
      this.datetimeSelect = []
    }
    this.refreshFirstPage()
  }

  // 首页刷新
  private refreshFirstPage() {
    this.currentPage = 1
    this.listData = []
    this.getLists(this.getHeaderParams())
  }

  // 获取顶部筛选的请求参数
  private getHeaderParams() {
    const params: any = {}
    if (this.navbarSearch !== '') {
      params.search = this.navbarSearch || ''
    }
    if (this.headerStatus && this.headerStatus !== '0') {
      params.status = this.headerStatus
      // if (this.headerStatus === '6' || this.headerStatus === '7') {
      //   params.is_official = this.headerStatus === '6' ? 1 : 0
      //   params.status = 3
      // }
    }
    if (this.headerType) {
      params.live_ticket_type = this.headerType
    }
    if ([2, 3, 4].includes(Number(this.headerStatus)) && this.headerIsMine) {
      params.me = this.headerIsMine
    }

    // datetime filter param
    if (this.datetimeSelect !== null && this.datetimeSelect.length > 0) {
      params.start_time = this.datetimeSelect[0]
      params.end_time = this.datetimeSelect[1]
    }

    if (this.issueType1Option !== '0') {
      params.issue_type_1 = this.issueType1Option
    }

    if (this.issueType2Option !== '0') {
      params.issue_type_2 = this.issueType2Option
    }

    params.place_id = this.areaOption

    return params
  }

  // 子组件接口调用成功后；
  private handleSuccess(res: any) {
    if (res.stat) {
      this.handleDetail(this.currentTicket)
      if (res.data) {
        this.$message({
          message: res.data,
          type: 'success',
          showClose: true
        })
      }
    }
  }

  // 获取正在操作的工单详情，并更新列表
  private handleDetail(ticket: any) {
    ORDERAPI.detailTicket({
      tid: ticket.tid,
      ticket_type: ticket.ticket_type,
      app_id: this.userCurrentApp
    })
      .then((res) => {
        TicketsModule.SetCurrentTicket({
          ticket: res.data,
          ticketIndex: this.currentTicketIndex
        })
        // 事件节点组件更新数据
        this.$refs.detailDialog &&
          (this.$refs.detailDialog as any).handleEvents()
        // 替换条件：全部列表 || 我发起的列表 || 转给个人
        if (
          (this.showStatusTab &&
            (this.headerStatus === '0' ||
              this.$route.name === 'myCreateedOrders')) ||
          res.data.is_forward === 1
        ) {
          // 替换列表第currentTicketIndex个的ticket
          (this.listData as any).splice(this.currentTicketIndex, 1, res.data)
        } else {
          // 删除当前ticket操作项；只前端隐藏，否则列表按钮对不上；
          this.$set(this.listData[this.currentTicketIndex], 'hidden', true)
          this.total--
        }
      })
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      .catch(() => {})
  }

  // 获取订单中心-所有订单列表
  private getAllOrderLists(params?: any) {
    const postData: any = Object.assign(
      {
        page: this.currentPage,
        page_size: this.pageSize,
        app_id: this.userCurrentApp
      },
      typeof params === 'object' ? params : {}
    )
    FWBZISORDERAPI.getAllAdminOrderList(postData)
      .then((res) => {
        this.thenHandler(res)
      })
      .catch(() => {
        this.catchHandler()
      })
  }

  // 发起人-我所有创建的工单
  private getAllMyCreatedOrderLists(params: any) {
    const postData: any = Object.assign(
      {
        page: this.currentPage,
        page_size: this.pageSize,
        app_id: this.userCurrentApp
      },
      typeof params === 'object' ? params : {}
    )
    FWBZISORDERAPI.getMyCreatedOrderList(postData)
      .then((res) => {
        this.thenHandler(res)
      })
      .catch(() => {
        this.catchHandler()
      })
  }

  // 受理人-我的所有工单
  private getAllMyManagedOrderLists(params: any) {
    const postData: any = Object.assign(
      {},
      typeof params === 'object' ? params : {}
    )
    this.getMyOrders(postData)
  }

  // 我的待受理
  private getMyPendingLists(params?: any) {
    const postData: any = Object.assign(
      {
        status: 1 // 待受理
      },
      typeof params === 'object' ? params : {}
    )
    this.getMyOrders(postData)
  }

  // 我的受理中工单
  private getMyAcceptedLists(params?: any) {
    const postData: any = Object.assign(
      {
        status: 2 // 处理中
      },
      typeof params === 'object' ? params : {}
    )
    this.getMyOrders(postData)
  }

  // 我的已完成
  private getMyFinishedLists(params?: any) {
    const postData: any = Object.assign(
      {
        status: 3
      },
      typeof params === 'object' ? params : {}
    )
    this.getMyOrders(postData)
  }

  // 我的已驳回
  private getMyRejectedLists(params?: any) {
    const postData: any = Object.assign(
      {
        status: 4
      },
      typeof params === 'object' ? params : {}
    )
    this.getMyOrders(postData)
  }

  // 我的已转接
  private getMyForwardedLists(params?: any) {
    const postData: any = Object.assign(
      {
        status: 5
      },
      typeof params === 'object' ? params : {}
    )
    this.getMyOrders(postData)
  }

  // 获取我的各种状态工单
  private getMyOrders(params: any) {
    const postData: any = Object.assign(
      {
        page: this.currentPage,
        page_size: this.pageSize,
        app_id: this.userCurrentApp
      },
      typeof params === 'object' ? params : {}
    )
    FWBZISORDERAPI.getMyOrderList(postData)
      .then((res) => {
        this.thenHandler(res)
      })
      .catch(() => {
        this.catchHandler()
      })
  }

  // 接口列表成功then
  private thenHandler(res: any) {
    this.total = res.data.count
    this.listData = this.listData.concat(res.data.lists)
    this.moreLoading = false
    this.pageLoading.close()
    this.loadHugeScreen()
  }

  // 列表接口错误catch
  private catchHandler() {
    this.total = 0
    this.moreLoading = false
    this.pageLoading.close()
  }

  // 导出Excel结果
  private handleExportExcel() {
    const content =
      this.datetimeSelect && this.datetimeSelect.length > 0
        ? `${this.datetimeSelect[0]} 至 ${this.datetimeSelect[1]}`
        : '全部'
    this.$confirm(`是否要导出 ${content} 数据？`, '数据导出', {
      type: 'warning'
    })
      .then((_) => {
        const params = {
          app_id: this.userCurrentApp,
          ...this.getHeaderParams()
        }
        return new Promise((resolve, reject) => {
          FWBZISORDERAPI.getLiveExportExcel(params)
            .then((res) => {
              if (res.size > 0) {
                downloadLink(res, `服务保障工单数据-${content}.xls`)
              } else {
                this.$message({
                  message: '当前所选时间段暂无可以导出的数据！',
                  type: 'error'
                })
              }
              resolve()
            })
            .catch((_) => {
              this.$message({
                message: '导出数据失败',
                type: 'error'
              })
            })
        })
      })
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      .catch((_) => {})
  }
}
